import {useContext} from "react";
import {NotificationContext} from "../../widget/Notifications";

export const useNotifications = () => {
  // noinspection JSUnusedLocalSymbols
  const [notifications, setNotification] = useContext(NotificationContext);

  async function addNotification(content, title, settings) {
    settings = {
      color: "primary",
      icon: undefined,
      progress: -1,
      hideDelay: 3500,
      ...settings
    }
    setNotification({
      title: title,
      content: content,
      color: settings.color,
      icon: settings.icon,
      progress: settings.progress,
      hideDelay: settings.hideDelay,
      visible: true
    });
  }

  async function addSuccessNotification(content, title) {
    return addNotification(content, title, {
      color: "success",
      progress: 100,
      icon: "check",
    });
  }

  async function addErrorNotification(content, title) {
    return addNotification(content, title, {
      color: "danger",
      progress: 100,
      icon: "times",
    });
  }

  async function addWarningNotification(content, title) {
    return addNotification(content, title, {
      color: "warning",
      progress: 100,
      icon: "ban",
    });
  }

  return {addNotification, addSuccessNotification, addErrorNotification, addWarningNotification};
}
